import { useEffect } from 'react';
import hubLayout from 'styles/css/hubLayout.module.css';
import Modal from "react-modal";
import { useForm } from 'react-hook-form';
import { createInCopyRecorder, maxLengthCheck } from 'api/api';
import { useModal } from 'components/common/ModalLayout';


function InCopyModal({ isOpen, setIsOpen, recorderIdx, onConfirm }: { isOpen: boolean, setIsOpen:Function, recorderIdx: number, onConfirm:Function }) {
    const { showModal } = useModal();
    // 내부복사 Modal
    const closeModal = () => {
      setIsOpen(false); 
      if (window.history.state?.modalIsOpen) {
          window.history.back(); // 히스토리 상태 복구
      }
    }

    // useForm
    const { register, formState: { errors, isValid }, getValues } = useForm<any>({
      mode: 'all',
    });

    const createInCopy = async () => {
      const response = await createInCopyRecorder({
        idx : recorderIdx,
        in_ip : getValues().in_ip1 + '.' + getValues().in_ip2 + '.' + getValues().in_ip3 + '.' + getValues().in_ip4,
        in_port : getValues().in_port,
      });
      if (response.code === 200) {
        showModal("alert", '장비 내부복사를 완료하였습니다.',
          {confirm: false, cancel: false},
          () => {
            onConfirm();
            closeModal();
          }
        );
      } else {
        showModal("alert", response.message);
      }
    };

    // 뒤로가기 이벤트 처리
    useEffect(() => {
      const handlePopState = () => {
        if (isOpen) {
          closeModal();
        }
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }, [isOpen]);
    return (
        <>
            <Modal
                isOpen={isOpen} // 모달 열림/닫힘 상태
                onRequestClose={closeModal} // 모달 외부 클릭 시 닫힘
                ariaHideApp={false}
                style={{
                    content: {
                        width: '100%',
                        maxWidth: '30rem',
                        top: "40%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        transform: "translate(-50%, -40%)",
                    },
                    overlay: {
                        zIndex: "10000",
                        backgroundColor: "rgba(0,0,0,.7)",
                    },
                }}
            >
                <h2 style={{ marginBottom: "1rem", color: "#000" }}>내부복사</h2>
                <div className={`${hubLayout.sec_title}`}>
                    <div className={`${hubLayout.acc_item_info}`}>
                        <p style={{ marginBottom: "1rem" }}>내부IP와 PORT를 입력 후 아래의 ‘확인＇을 눌러주세요.</p>
                        <dl style={{ marginBottom: "1rem" }}>
                            <dt>내부 IP</dt>
                            <dd>
                                <input type="number" className={`${errors.in_ip1 && hubLayout.border_red}`} style={{ width: '24%' }} maxLength={3}
                                    {...register(`in_ip1`, {
                                        required: true,
                                        onChange: (e:any) => maxLengthCheck(e),
                                    })}
                                />
                                .
                                <input type="number" className={`${errors.in_ip2 && hubLayout.border_red}`} style={{ width: '24%' }} maxLength={3}
                                    {...register(`in_ip2`, {
                                        required: true,
                                        onChange: (e:any) => maxLengthCheck(e),
                                    })}
                                />
                                .
                                <input type="number" className={`${errors.in_ip3 && hubLayout.border_red}`} style={{ width: '24%' }} maxLength={3}
                                    {...register(`in_ip3`, {
                                        required: true,
                                        onChange: (e:any) => maxLengthCheck(e),
                                    })}
                                />
                                .
                                <input type="number" className={`${errors.in_ip4 && hubLayout.border_red}`} style={{ width: '24%' }} maxLength={3}
                                    {...register(`in_ip4`, {
                                        required: true,
                                        onChange: (e:any) => maxLengthCheck(e),
                                    })}
                                />
                            </dd>
                        </dl>
                        <dl>
                            <dt>내부 PORT</dt>
                            <dd>
                                <input type="number" className={`${errors.in_port && hubLayout.border_red}`}
                                    placeholder="내부 PORT"
                                    {...register(`in_port`, {
                                        required: true,
                                    })}
                                />
                            </dd>
                        </dl>
                    </div>
                </div>
                <div className={`${hubLayout.btn_group} `}>
                    <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.pink}`} onClick={closeModal}>취소</button>
                    <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={createInCopy} disabled={!isValid}>확인</button>
                </div>
            </Modal>
        </>
    );
}

export default InCopyModal;